import React, { useContext, useMemo } from 'react';
import { RestaurantsContext, IRestaurantsContext } from '../../../restaurantsState/restaurantsContext';
import { entityStatuses } from 'appConstants';
import { useTranslation } from 'react-i18next';
import OutsideFormSelect from 'components/Select/OutsideFormSelect';

export const StatusSelect: React.FC = () => {
	const { setStatus, status } = useContext<IRestaurantsContext>(RestaurantsContext);
	const { t } = useTranslation('listing');

	const options = useMemo(
		() =>
			entityStatuses.map((entityStatus) => ({
				id: entityStatus.id,
				name: t(entityStatus.name),
			})),
		[t],
	);

	return (
		<OutsideFormSelect
			className="!mt-0"
			containerClassName="!min-h-min w-px"
			testId="StatusSelect"
			name="StatusSelect"
			label="statusLabel"
			onChange={setStatus}
			value={status}
			options={options}
			listItemHeight={options.length}
			withSearch={false}
			allowClear={false}
			withValidation={false}
			withEmptyOption={false}
		/>
	);
};
